import styled from 'styled-components'

const H1 = styled.h1 `
  font-size: 31px;
  font-weight: 300;
  text-align: center;
  max-width: 820px;
  line-height: 1.4;
  letter-spacing: 3px;
`

export { H1 }
